import { createEntityAdapter, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../staticData/staticData";
import dayjs from 'dayjs';
import * as Sentry from "@sentry/react";
const whsAdapter=createEntityAdapter();
const initialState=whsAdapter.getInitialState({
    entities:{
        currWhs:{
        date:"",
        site: "",
        driver: "",
        driverId:"",
        vehicle:[],
        odometer:"",
        serviceDueKm:"",
        visualInspection:false,
        visualInspectionComment:"",
        interiorClean:false,
        exteriorClean:false,
        cleanlinessComment:"",
        firstAid:false,
        missingPass:false
    }
    }
});
const serverURL=server
export const getWhsById=createAsyncThunk('whs/getwhsbyid', async ({whsId,driverId})=>{
     const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        const response=await axios.get(serverURL+"drivertempcheck/whs/"+whsId+"/"+driverId,config);
        return response.data;
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Eror getWhsById, driverId: "+driverId +", whsId: "+whsId);
    }
})
export const getListWhs=createAsyncThunk('whs/getlistwhs', async ({day, site, runId, driverId})=>{
    const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        const response=await axios.get(serverURL+"drivertempcheck/whs?&driverId="+driverId,config);
        return response.data;   
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error getListWhs, driverId: "+driverId);
    }
})
export const createNewWhs=createAsyncThunk('whs/createnewWhs', async ({data,driverId})=>{
     const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        data.version="1";
        data.company="thefruitbox"
        const response=await axios.post(serverURL+"drivertempcheck/whs/",data,config);
        return response.data;   
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error createNewWhs, driverId: "+driverId+", data: "+JSON.stringify(data));
        return error
    }
})
export const updateNewWhs=createAsyncThunk('whs/updatenewWhs', async ({data,driverId})=>{
     const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        data.version="1";
        data.company="thefruitbox"
        const response=await axios.put(serverURL+"drivertempcheck/whs/"+data.id,data,config);
        return response.data;   
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error updateNewWhs, driverId: "+driverId+", data: "+JSON.stringify(data));
    }
})
const whsSlice=createSlice({
    name:'whs',
    initialState,
    reducers:{
        resetWhsState:(state)=>state=initialState,
        resetWhsNavigation:(state)=>{state.entities.whsNavigation={}}
    },
    extraReducers: (builder)=>{
        builder.addCase(getWhsById.fulfilled,(state,action)=>{
            state.status="success"
            state.entities.currWhs=action.payload;
        })
        .addCase(getWhsById.pending, (state,action)=>{
            state.status="pending"
        })
        .addCase(getWhsById.rejected, (state,action)=>{
            state.status="idle"
            state.entities.currReport.deliveryDate=dayjs(dayjs(action.payload.deliveryDate).format("YYYY-MM-DD").toString()+"T00:00:00.000Z").toISOString();
        })
        .addCase(createNewWhs.fulfilled,(state, action)=>{
            state.status="success"
            if(action.payload.name && action.payload.name.toLowerCase().includes("error")){
                state.entities.error=action.payload.name
            }
            else{
                state.entities.error=""
                state.entities.whsNavigation=action.payload.data
            }
        })
        .addCase(createNewWhs.pending,(state, action)=>{
            state.status="pending"
        })
        .addCase(createNewWhs.rejected,(state, action)=>{
            state.status="idle"
        })
        .addCase(getListWhs.fulfilled,(state,action)=>{
            state.status="success"
            state.entities.whsList=action.payload
        })
        .addCase(getListWhs.pending,(state,action)=>{
            state.status="pending"
        })
        .addCase(getListWhs.rejected,(state,action)=>{
            state.status="idle"
        })
        .addCase(updateNewWhs.fulfilled,(state, action)=>{
            state.status="success"
        })
        
        .addCase(updateNewWhs.pending,(state, action)=>{
            state.status="pending"
        })
        .addCase(updateNewWhs.rejected,(state, action)=>{
            state.status="idle"
        })
    }
})
export default whsSlice.reducer;
export const {resetWhsState, resetWhsNavigation}=whsSlice.actions;